function resolveApiBaseUrl(): string {
  if (process.env.REACT_APP_ENV !== 'development') {
    const envUrl = new URL(process.env.REACT_APP_API_URL || '');
    const apiSubdomain = envUrl.hostname.split('.')[0];
    const parts = window.location.hostname.split('.');
    parts[0] = apiSubdomain;
    return `https://${parts.join('.')}${envUrl.pathname}`;
  }
  return process.env.REACT_APP_API_URL || '';
}

export const API_BASE_URL = resolveApiBaseUrl();

// Replaces only the domain part of a URL, keeping subdomain + path + query from env.
// e.g. unstable-grafana.xbit.live/... on admin.asdw.live → unstable-grafana.asdw.live/...
export function resolveDomainUrl(envUrl: string | undefined): string {
  if (!envUrl) return '';
  if (process.env.REACT_APP_ENV !== 'unstable') return envUrl;
  const parsed = new URL(envUrl);
  const subdomain = parsed.hostname.split('.')[0];
  const currentDomain = window.location.hostname.split('.').slice(1).join('.');
  return `${parsed.protocol}//${subdomain}.${currentDomain}${parsed.pathname}${parsed.search}`;
}
